<template>
  <div>
    <card style="margin-bottom: 0px;border-bottom: none;border-bottom-left-radius: 0;border-bottom-right-radius: 0;">
      <template slot="header">
        {{ warehouse ? warehouse.name : '' }}
      </template>
    </card>
    <table class="table table-striped table-bordered">
      <thead>
        <tr>
          <th>Produkt</th>
          <th class="text-center">Derzeitiger Lagerstand</th>
          <th class="text-center">
            Warnschwelle
            <span v-tooltip.top-center="'Wird dieser Wert unterschritten wird eine Warnung angezeigt, dass das Produkt nachbestellt werden muss'">
              <i class="fas fa-question-circle"></i>
            </span>
          </th>
          <th class="text-center">
            Sollmenge
            <span v-tooltip.top-center="'Hier können Sie den Ziellagerstand den Sie im Lager anstreben angeben, dies ist hilfreich um z.B. bei Neubestellung wenn die Warnschwelle erreicht ist zu wissen, wieviel Produkte bestellt werden sollen'">
              <i class="fas fa-question-circle"></i>
            </span>
          </th>
          <th style="width: 50px;"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="warehouseProduct in warehouseProducts"
          :key="warehouseProduct.id"
          :warehouse-product="warehouseProduct"
          is="ProductWarehouseConfigRow"
        />
      </tbody>
    </table>
  </div>
</template>

<script>
import ProductWarehouseConfigRow from './ProductWarehouseConfigRow.vue'

export default {
  props: [],
  components: {
    ProductWarehouseConfigRow
  },
  data () {
    return {
      warehouse: null,
      warehouseProducts: []
    }
  },
  created () {
    this.$http.get(`/warehouses/${this.$route.params.id}`).then(({ data }) => {
      this.warehouse = data
    })
    this.$http.get(`warehouses/${this.$route.params.id}/product_config`).then(({ data }) => {
      this.warehouseProducts = data
    })
  }
}
</script>
